$(document).ready(function() {

    $("#newsletter-form").on('submit', function(e) {
        //prevent form from submitting

        e.preventDefault();
        $("#newsletter-form").fadeOut(500);
        $.post($(this).attr('data-action'), $(this).serialize(), function(data) {
            if (data == "success") {
                $(".newsletter-form-confirmation").fadeIn(500);
            } else {
                $("#newsletter-form").fadeOut(500);
            }
            
        });
    });
});


// WEBPACK FOOTER //
// ./app/src/assets/js/partials/subscribe.js